import { handleApiResponse, notify } from '@/functions';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IPaymentProvider } from '@/interfaces/paymentProvider.interface';

type TVariables = { providers: IPaymentProvider[] };

export const useRequestSetPaymentProviders = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.paymentProviders, 'set'],
    mutationFn: ({ providers }: TVariables) =>
      apiClient
        .post<void>(routes.api.paymentProviders, { providers })
        .then(handleApiResponse)
        .catch(error => {
          notify(error?.internalMessage, 'error');
          throw error;
        }),
    onSuccess: () => invalidate(routes.api.paymentProviders)
  });

  const triggerSetPaymentProviders = (providers: IPaymentProvider[]) =>
    mutateAsync({ providers });

  return ({
    isLoadingSetPaymentProviders: isPending,
    triggerSetPaymentProviders,
    error
  });

};
